var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-background"},[_c('div',{staticClass:"login-left"}),_c('div',{staticClass:"login-right"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }